import React from 'react'
import axios from "axios";
import { useSelector } from 'react-redux';
export const useAxios = () => {
  const token = useSelector(state=>state.authentication.token)
  return  axios.create({
    baseURL:process.env.REACT_APP_BACKEND_URL,
    headers:{
      "Application-Version":process.env.REACT_APP_APP_VERSION,
      Authorization:`Bearer ${token}`,
      "Accept":"application/json"
    }
  })
}
